import React from 'react'
import './scroll.scss'
const Scroll = () => {
    return (
        <div className="scroll-container">
            <div className="scroll-ball"></div>
            <div className="scroll-text"><p>Scroll</p></div>
            <div className="scroll-line"></div>
        </div>
    )
}

export default Scroll
